var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.654839 6.04172H1.7463C1.87754 6.94347 2.32906 7.76783 3.01826 8.36399C3.70745 8.96014 4.58825 9.28823 5.4995 9.28823C6.41076 9.28823 7.29156 8.96014 7.98075 8.36399C8.66995 7.76783 9.12147 6.94347 9.25271 6.04172H10.3447C10.2112 7.23331 9.64321 8.3339 8.74938 9.13315C7.85556 9.9324 6.69855 10.3742 5.4995 10.3742C4.30045 10.3742 3.14345 9.9324 2.24963 9.13315C1.3558 8.3339 0.787841 7.23331 0.654297 6.04172H0.654839ZM0.654839 4.95838C0.788383 3.76679 1.35634 2.6662 2.25017 1.86695C3.14399 1.0677 4.301 0.625854 5.50005 0.625854C6.6991 0.625854 7.8561 1.0677 8.74993 1.86695C9.64375 2.6662 10.2117 3.76679 10.3453 4.95838H9.2538C9.12255 4.05663 8.67103 3.23227 7.98184 2.63611C7.29264 2.03996 6.41185 1.71188 5.50059 1.71188C4.58933 1.71188 3.70854 2.03996 3.01934 2.63611C2.33014 3.23227 1.87862 4.05663 1.74738 4.95838H0.654839Z",
    fill: "black",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.14096458303627cb75474c6e9299a363.svg";
export { ForwardRef as ReactComponent };